/**
 * use-element-width.ts — Bề rộng (px) của một phần tử, cập nhật khi nó đổi kích cỡ (kéo thanh chia cột, mở / đóng cột hồ sơ, đổi cỡ cửa sổ).
 * Đo bằng useLayoutEffect nên có giá trị TRƯỚC khi vẽ lần đầu; 0 = chưa đo.
 */
import { useLayoutEffect, useRef, useState } from 'react'

export function useElementWidth<T extends HTMLElement>(): [React.RefObject<T>, number] {
  const ref = useRef<T>(null)
  const [width, setWidth] = useState(0)
  useLayoutEffect(() => {
    const el = ref.current
    if (!el) return
    setWidth(Math.round(el.getBoundingClientRect().width))
    if (typeof ResizeObserver === 'undefined') return
    const ro = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect.width
      if (typeof w === 'number') setWidth(Math.round(w))
    })
    ro.observe(el)
    return () => ro.disconnect()
  }, [])
  return [ref as React.RefObject<T>, width]
}
